module.exports = __webpack_public_path__ + "img/company7.81ae3988.png";